



















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class CardTab extends Vue {
    @Prop({ type: Array, default: [] })
    tabs?: InlineTab[];

    @Prop({ type: Object })
    activeTab?: InlineTab;

    isLeft: boolean = false;
    get getName() {
        if (this.isLeft) return "tab-item-left";
        else return "tab-item-right";
    }

    mounted() {
        this.resizeActive();
    }

    resizeActive() {
        this.$nextTick(() => {
            let bar: HTMLElement = <HTMLElement>(
                    document.querySelector(".tab-nav .active-line")
                ),
                w: HTMLElement = <HTMLElement>(
                    document.querySelector(".active-tab")
                );

            bar.style.width = w.clientWidth - 30 + "px";
            bar.style.transform = "translateX(" + w.offsetLeft + "px)";
        });
    }

    @Watch("activeTab")
    tabChange(val: InlineTab, before: InlineTab) {
        if (before.id < val.id) this.isLeft = false;
        else this.isLeft = true;
        this.resizeActive();
    }

    // 切换标签页
    clickTab(e: any, tab: InlineTab, index: number) {
        this.$emit("update:activeTab", tab);
        this.$emit("change", tab);
    }
}
